const ALLOWED_TABLES = new Set(["patient_profiles", "doctor_profiles"]);

export function normalizePasscodeRole(role = "", profileTable = "") {
  const clean = String(role || "").trim().toLowerCase();
  if (clean === "doctor" || clean === "patient") return clean;
  if (profileTable === "doctor_profiles") return "doctor";
  if (profileTable === "patient_profiles") return "patient";
  return "patient";
}

export function sanitizeDiagnosticMessage(value = "") {
  return String(value || "")
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, "[redacted-email]")
    .replace(/\+?\d[\d\s().-]{6,}\d/g, "[redacted-number]")
    .trim()
    .slice(0, 240);
}

export function buildPasscodeFailureDiagnostic({
  userId = "",
  role = "",
  profileTable = "",
  status = "",
  message = "",
  onboardingStep = "step_passcode_confirm",
  timestamp = new Date().toISOString(),
} = {}) {
  const cleanUserId = String(userId || "").trim();
  const cleanTable = String(profileTable || "").trim();
  if (!cleanUserId || !ALLOWED_TABLES.has(cleanTable)) return null;

  return {
    user_id: cleanUserId,
    role: normalizePasscodeRole(role, cleanTable),
    route: "/onboarding/passcode",
    event_type: "passcode_failure",
    metadata: {
      target_table: cleanTable,
      status: String(status || "unknown").trim() || "unknown",
      edge_function_message: sanitizeDiagnosticMessage(message),
      onboarding_step: String(onboardingStep || "step_passcode_confirm").trim(),
      timestamp: String(timestamp || new Date().toISOString()),
      source: "set-passcode",
    },
  };
}

export async function logPasscodeFailureDiagnostic(supabase, input = {}) {
  const payload = buildPasscodeFailureDiagnostic(input);
  if (!supabase || !payload) return false;

  const { error } = await supabase.from("user_activity_events").insert(payload);
  if (error) throw error;
  return true;
}
